import { render, staticRenderFns } from "./ImgInputer.vue?vue&type=template&id=e5f205dc"
import script from "./ImgInputer.vue?vue&type=script&lang=ts"
export * from "./ImgInputer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports